import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import { RowView } from "../../../../Component/style/common_style";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import url from "../../../../Component/server";

interface LoginModalProps extends modalProps {
  setTryLogin: React.Dispatch<React.SetStateAction<boolean>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setBlockModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const LoginModal = ({
  visible,
  handleModal,
  setTryLogin,
  setLoading,
  setBlockModal,
}: LoginModalProps) => {
  const Navigate = useNavigate();
  const closeModal = () => {
    handleModal();
  };
  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const [searchParams] = useSearchParams();

  const key = "bfc0b55461d3a48664f338e84ed7d158"; // js키
  // const key = "216faea67b46a8dd403e34b17dd5dff9"; // js키 테스트앱
  // const redirectURI = "http://192.168.0.29:3000";
  const redirectURI = "https://fanbird.live";

  const goKaKaoLogin = () => {
    window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${key}&redirect_uri=${redirectURI}&response_type=code`;
  };

  useEffect(() => {
    if (localStorage.getItem("key") !== null) {
      // refresh를 가지고 있을 시
      return;
    }
    const code = searchParams.get("code");
    if (code) {
      fetchToken(code);
      setLoading(true);
    }
  }, [searchParams]);

  const fetchToken = async (code: string) => {
    const tokenUrl = "https://kauth.kakao.com/oauth/token";
    const data = {
      grant_type: "authorization_code",
      client_id: key,
      redirect_uri: redirectURI,
      code: code,
    };

    try {
      const response = await fetch(tokenUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data),
      });
      const res = await response.json();
      getKaKaoInfo(res.access_token);
    } catch (err) {
      console.log("kakaocode 거부", err);
    }
  };
  const getKaKaoInfo = async (token: string) => {
    const userUrl = "https://kapi.kakao.com/v2/user/me";

    try {
      const response = await fetch(userUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      const res = await response.json();
      if (res) {
        const userinfo = {
          userid: res.id,
          name: res.kakao_account?.name || "",
          phone: res.kakao_account?.phone_number?.replace("+82 ", "0") || "",
        };
        sns_login(userinfo);
      }
    } catch (err) {
      console.log("실패", err);
      setLoading(false);
    }
  };

  const sns_login = (userinfo: {
    userid: string;
    name: string;
    phone: string;
  }) => {
    axios
      .post(
        url.Communication_url.user_login,
        {
          userid: userinfo.userid,
        },
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }
      )
      .then((res) => {
        const userinfo = res.data;
        if (userinfo.accessToken) {
          const token_refresh = userinfo.refreshToken;
          localStorage.setItem("key", token_refresh);
          setTryLogin(true);
        }
      })
      .catch((err) => {
        const errRes = err;
        if (errRes.response.status === 404) {
          Navigate("/signup", {
            state: userinfo,
          });
          return;
        }
        if (errRes.response.status === 403) {
          closeModal();
          setBlockModal(true);
          return;
        }
        console.error("Login Error", errRes);
      });
  };

  const fakeLogin = () => {
    const userinfo = {
      userid: "test",
      name: "테스트",
      phone: "010000000000",
    };
    sns_login(userinfo);
    closeModal();
  };

  return (
    <Container style={visible ? {} : { display: "none" }} onClick={closeModal}>
      <ModalBox onClick={stopPropagation}>
        <Title>로그인</Title>
        <ContentDiv>
          <div>로그인 후 이용하실 수 있어요.</div>

          <div style={{ marginTop: 4 }}>
            로그인하고 특가 상품을 득템해 보세요!
          </div>
        </ContentDiv>
        <BtnDiv>
          <CancelBtn onClick={closeModal}>취소</CancelBtn>
          <ApplyBtn onClick={goKaKaoLogin}>카카오 로그인</ApplyBtn>
          {/* <ApplyBtn onClick={fakeLogin}>카카오 로그인</ApplyBtn> */}
        </BtnDiv>
      </ModalBox>
    </Container>
  );
};
export default LoginModal;

const Container = styled.div`
  z-index: 99;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 25rem;
  margin: auto 0rem;
  background-color: white;
  color: #2d2d2d;
  border-radius: 8px;
  overflow: hidden;
  padding: 28px 24px;
  div.info {
    color: #8e8e8e;
    font-size: 14px;
    text-align: center;
    line-height: 19px;
  }
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 20px;
  font-family: var(--font-Pretendard-SemiBold);
`;

const ContentDiv = styled.div`
  padding: 20px 0px;
  display: flex;
  font-size: 16px;
  font-family: var(--font-Pretendard-Regular);
  flex-direction: column;
  color: #2d2d2d;
`;

const BtnDiv = styled(RowView)`
  position: relative;
  width: 100%;
`;

const Btn = styled.div`
  border-radius: 8px;
  padding: 14px 0px;
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 16px;
  font-family: var(--font-Pretendard-SemiBold);
  margin-top: 15px;
  cursor: pointer;
`;

const CancelBtn = styled(Btn)`
  margin-right: 5px;
  background-color: #f8f8f8;
  color: #8e8e8e;
`;

const ApplyBtn = styled(Btn)`
  margin-left: 5px;
  background-color: #ffeb33;
  color: black;
`;
